// App Configuration Constants
// This file centralizes URLs and configuration to avoid drift

export const PDF_URL = 'https://customer-assets.emergentagent.com/job_dbconn-workbook/artifacts/nczu13e4_BelongingSessions%20PDF.pdf';

export const APP_CONFIG = {
  // PDF Downloads
  workbookPdfUrl: PDF_URL,
  workbookPdfFilename: 'Belonging_Sessions_eBook.pdf',
  
  // Routes
  belongingEbookRoute: '/belonging-ebook',
  legacyTeachersGuideRoute: '/teachers-guide',
  
  // App Info
  appName: 'The Belonging Sessions',
  organizationName: 'Defiance Springs',
  
  // Bell Hooks Quote
  bellHooksQuote: {
    text: "I dreamed about a culture of belonging. I still dream that dream. I contemplate what our lives would be like if we knew how to cultivate awareness, to live mindfully, peacefully; if we learned habits of being that would bring us closer together, that would help us build beloved community.",
    author: "bell hooks",
    source: "Belonging: A Culture of Place"
  }
};

export default APP_CONFIG;
